var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    stroke: "none",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0765 6.88859C19.3764 7.4441 17.1097 5.22205 17.6764 3.55551M17.5389 3.6903L13.8762 7.28073C12.2839 8.84163 11.1543 10.7974 10.6081 12.9389L10.4311 13.6329C10.376 13.8491 10.5758 14.045 10.7964 13.9909L11.5043 13.8174C13.6889 13.282 15.684 12.1747 17.2763 10.6138L20.939 7.02338C21.3899 6.58139 21.6432 5.98192 21.6432 5.35684C21.6432 4.05519 20.5668 3 19.2389 3C18.6013 3 17.9898 3.24831 17.5389 3.6903Z",
    stroke: "#363853",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4623 3C11.4184 3 10.3745 3.11763 9.35141 3.35288C6.5181 4.00437 4.30583 6.17301 3.64123 8.95043C3.16126 10.9563 3.16126 13.0437 3.64123 15.0496C4.30583 17.827 6.5181 19.9956 9.35141 20.6471C11.3976 21.1176 13.5271 21.1176 15.5733 20.6471C18.4066 19.9956 20.6188 17.827 21.2834 15.0496C21.5234 14.0466 21.6434 13.0233 21.6434 12",
    stroke: "#363853",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/editIcon.722ac7642f131cbb34097243c442de68.svg";
export { ForwardRef as ReactComponent };